const modals: { id: string; cb: () => void }[] = []

export function registerModal(id: string, cb: () => void) {
  const modal = modals.find((m) => m.id === id)
  if (modal) {
    // already registered, update callback
    modal.cb = cb
    return
  }
  modals.push({ id, cb })
}

export function unregisterModal(id: string) {
  const modal = modals.find((m) => m.id === id)
  if (!modal) return

  modal.cb()
  modals.splice(modals.indexOf(modal), 1)
}

export function popModal() {
  const modal = modals.pop()
  if (!modal) return false

  modal.cb()
  return true
}
